import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsOpportunitiesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Opportunities</div>
          <div className="text">
            An opportunity represents a potential customer, synced in from Salesforce or Hubspot.
            The API allows you to fetch the list of opportunities linked to posts in&nbsp;Canny.
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
